import { ISidebarConfig, ISidebarSection } from '../components/sidebar-menu/sidebar-menu.interface';
import { BASE_SIDEBAR_SECTION } from './base.config';
import { GUARD_SIDEBAR_SECTION } from './guard.config';

export const HR_SIDEBAR_SECTION: ISidebarSection = {
    id: 'funcionarios',
    title: 'Recursos Humanos',
    items: [
        {
            id: 'funcionarios',
            title: 'Funcionários',
            route: '/hr/funcionarios',
            icon: 'users',
            isVisible: true,
        },
        {
            id: 'gestion',
            title: 'Gestão',
            icon: 'report',
            isVisible: true,
            children: [
                {
                    id: 'vacation-schedule-model',
                    title: 'Modelo Escala de Férias',
                    route: '/hr/escala-ferias',
                    isVisible: true,
                },
                {
                    id: 'food-basket',
                    title: 'Entrega de Cesta Básica',
                    route: '/hr/cesta-basica',
                    isVisible: true,
                },
                {
                    id: 'disciplinary-warning',
                    title: 'Carta de Advertência Disciplinar',
                    route: '/hr/advertencia-disciplinar',
                    isVisible: true,
                },
                {
                    id: 'termination',
                    title: 'Desligamento',
                    route: '/hr/desligamento',
                    isVisible: true,
                },
            ],
        },
    ],
    isVisible: true,
};

export const HR_SIDEBAR_CONFIG: ISidebarConfig = {
    role: 'HR',
    sections: [BASE_SIDEBAR_SECTION, HR_SIDEBAR_SECTION, GUARD_SIDEBAR_SECTION],
};
